<template>
  <div class="telemetria" style="background-color:#ffffff; border-radius: 20px;">

    <vue-element-loading :active="cargando" spinner="bar-fade-scale" color="#064dc3" size="120" :is-full-screen="true" text="Cargando..."/>
    <div class="form-row">
      <h1 class="col-8">Reporte de Ticket Salida</h1>
      <div class="col-3"></div>
      <router-link to="/home">
        <b-button variant="outline-success" style="margin: 10px">
          <div class="h6 mb-1">
            <b-icon-arrow-left-square></b-icon-arrow-left-square>
          </div>
          <div style="font-size: 12px;">
            Inicio
          </div>
        </b-button>
      </router-link>
    </div>

    <div class="row">
      <div class="col-12">
        <label class="col-form-label">Unidades</label>
        <multiselect ref="select" v-model="dispositivosSeleccionados" placeholder="Seleccione los dispositivos" label="name" track-by="id" :options="dispositivosObtenidos" :multiple="true" :hide-selected="true" select-label="Seleccionar" deselect-label="Remover"
        >
        </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectAll">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAll">Limpiar</button>
      </div>
      
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaInicio">
      </div>
     <!-- <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaInicio">
      </div>-->
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaFin">
      </div>
    <!--  <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaFin">
      </div>-->
    </div>
    <button class="btn btn-sm btn-primary mt-3" @click="generarReporte()">Generar reporte</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Exportar Excel</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportCSV()">Exportar CSV</button>
    <div class="table-responsive mt-4">
      <table class="table table-bordered table-hover text-center">
        <thead style="background-color: #05123C;">
          <tr class="text-white">
            <th>Unidad</th>
            <th>Lectora</th>
            <th>Camara</th>
            <th>Gps</th>
            <th>Observaciones</th>
            <th>Nu.Empleado</th>
            <th>Operador</th>
            <th>Sucursal</th>
            <th>Bus</th>
            <th>Fecha</th>
            <th>Usuario GPS</th>
            
            <!--<th>Frenado Brusco</th>-->
            <!--<th>Hora</th>-->
            <!--<th>Aceleracion Brusca</th>-->
            <!--<th>Latitud</th>
            <th>Longitud</th>-->
            
            <!--<th>Velocidad Proyectada</th>-->
            <!--<th>Velocidad Permitida</th>-->
            
            <!--<th>Ubicacion</th>-->
            <!-- <th>Horas motor</th> -->
            <!-- <th>Combustible utilizado</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item of formatearDatos">
            <td>{{ item.unidad}}</td>
            <td >{{ item.lectora}}</td>
            <td >{{ item.camara}}</td>            
            <td v-if="item.gps">Si</td>
            <td v-else>No</td>         
            <td>{{ item.observaciones}}</td>
            <td>{{ item.numeroempleado}}</td>
            <td>{{ item.operador}}</td>
            <td>{{ item.sucursal}}</td>
            <td>{{ item.bus}}</td>
            <td>{{ item.fecha}}</td>
            <td>{{ item.email}}</td>
            <!--<td>{{ item.address}}</td>-->
            <!--<td>{{(item.deviceId).substr(-3)}}</td>-->
            <!--<td v-if="item.ExcesoVelocidad == 'Sin datos'"></td>
            <td v-else>{{ item.ExcesoVelocidad }}</td>-->
            <!--<td >{{ item.ExcesoVelocidad }}</td>-->
            <!--<td v-if="item.FrenadoBrusco == 2">Frenado Brusco</td>
            <td v-else></td>-->
             <!--<td>{{ item.FrenadoBrusco}}</td>
            <td v-if="item.AceleracionBrusca == 1">Aceleracion Brusca</td>
            <td v-else></td>-->
           <!-- <td>{{item.deviceTime}}</td>-->
            <!--<td>99</td>
            <td>70</td>
            <td>1:20</td>-->
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>

import { mapState, mapMutations, mapActions } from "vuex";
//import {mostrarMensajeErrorCatch, mostrarMensajeInformativo, mostrarMensajeExitoso, mostrarMensajeError} from '../../mixins/mensajes';

export default {
  data() {
    return {
      dispositivosObtenidos: [],
      dispositivosSeleccionados: [],
      dispositivosSeleccionados2: [],
      gruposObtenidos: [],
      posiciones:[],
      eventos:'',
      gruposSeleccionados: [],
      gruposSeleccionados2: [],
      geocercasObtenidas: [],
      fechaInicio: '',
      horaInicio: '00:00',
      fechaFin: '',
      horaFin: '23:59',
      datosReporte: [],
      datosReporte2: []
    }
  },
  watch: {
    dispositivosSeleccionados(newSelected) {
  
     
      this.dispositivosSeleccionados = newSelected;
      
    },
    gruposSeleccionados(newSelected) {
  
     
  this.gruposSeleccionados = newSelected;

}
  },


  computed: {
    ...mapState({
      catUnidades: state => state.catalogos.catUnidades
    }),

    ...mapState(["cargando"]),

    formatearIds() {
      //let data = '';
      var index = 0;
      this.dispositivosSeleccionados2 = [];
      for (let item of this.dispositivosSeleccionados) {
        //(index == 0) ? data += 'deviceId=' + item.id : data += '&deviceId=' + item.id;
        this.dispositivosSeleccionados2.push(item.name);
        index++;
      }
      return this.dispositivosSeleccionados2;
    },
    
    formatearPosition() {
      let data = '';
           var index = 0;
          for (let item of this.datosReporte) {
          (index == 0) ? data += 'id=' + item.positionId : data += '&id=' + item.positionId;
           index++;
           }
      return data;
    },

    formatearIdGrupo() {
       var index = 0;
       this.gruposSeleccionados2= [];
      for (let item of this.gruposSeleccionados) {
        this.gruposSeleccionados2.push(item.id);
        index++;
      }
      return this.gruposSeleccionados2;
    },

    formatearDatos() {
      var index = 0;
      
     console.log(this.datosReporte);
   
      return this.datosReporte;
    }


  },

 
  methods: {
    ...mapActions("catalogos", ["obtenerUnidades"]),
    ...mapMutations(["setearCargando"]),

    obtenerSesion() {
      let params = new URLSearchParams();
      params.append("email", "desarrollo.gps@busmen.com");
      params.append("password", "12345");
      let headers = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };

      axios.post(`${url}session`, params, JSON.parse(localStorage.user))
        .then(response => {
          console.log("Sesion");
        })
        .catch(error => {
          console.log("No sesion");
        });
    },

    generarReporte() {
      if (this.fechaInicio !='' & this.fechaFin.length !='' & this.gruposSeleccionados.length !='' || this.dispositivosSeleccionados.length!='' & this.fechaInicio !='' & this.fechaFin.length !='') {
        let fechaInicio = encodeURIComponent( new Date(this.fechaInicio + ' ' + this.horaInicio).toISOString().split('.')[0]+"Z" );
        let fechaFin = encodeURIComponent( new Date(this.fechaFin + ' ' + this.horaFin).toISOString().split('.')[0]+"Z" );

        this.setearCargando(true);
        //this.reporteTelemetrias(fechaInicio, fechaFin);
       
          this.reporteCompleto(fechaInicio, fechaFin);
       
      }
      
      else if(this.fechaInicio != '' & this.fechaFin.length != ''){
        alert("Debe seleccionar al menos Unidad");
      }
     
      
    },

    reporteDispositivos(fechaInicio, fechaFin){
      axios.get(`${url}reports/summary?${this.formatearIds}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },

    /*reporteGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/events?${this.formatearIdGrupo}&type=deviceOverspeed&from=${fechaInicio}&to=${fechaFin}` , headers)
        .then(response => {
          this.datosReporte = response.data;
           axios.get(`${url}positions?${this.formatearPosition}` , headers)
        .then(response => {
          this.datosReporte2 = response.data;         
          this.setearCargando(false);
        }) 
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },*/
    
  
    
    reporteCompleto(fechaInicio, fechaFin){
      axios.post(`https://soporte.geovoy.com/api/salidasTaller`,{
        'unidad' : this.formatearIds,'FechaInicio' : this.fechaInicio + ' ' + this.horaInicio, 'FechaFin' : this.fechaFin + ' ' + this.horaFin }, {
        headers: {'content-type' : 'application/json'}})
      .then(response => {
          this.datosReporte = response.data;
          console.log("response");
          console.log(response);
        // this.removeAll();
          //console.log(this.datosReporte)
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },
  
    
    /*reporteTelemetrias(fechaInicio, fechaFin){
     axios.get(`${url}reports/events?${this.formatearIds}&type=deviceOverspeed&from=${fechaInicio}&to=${fechaFin}` , headers)
        .then(response => {
          this.datosReporte = response.data;*/
         
          /*var uniqs = this.posiciones.filter(function(item, index, array) {
          return array.indexOf(item) === index;
             })*/
          //console.log(uniqs);
         /* axios.get(`${url}positions?${this.formatearPosition}` , headers)
        .then(response => {
          this.datosReporte2 = response.data;         
          this.setearCargando(false);
        }) 
          this.setearCargando(false);
        })
      
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },*/
    
    selectAll() {
      this.dispositivosSeleccionados = [];
      for (let item of this.dispositivosObtenidos) {
          this.dispositivosSeleccionados.push(item);
      }
    },
     selectAllGrupos() {
      this.gruposSeleccionados = [];
      for (let item of this.gruposObtenidos) {
          this.gruposSeleccionados.push(item);
      }
    },

    removeAll() {
      this.dispositivosSeleccionados = [];
      this.dispositivosSeleccionados2 = [];
      this.gruposSeleccionados = [];
      this.gruposSeleccionados2 = [];
    },
    
    removeAllGrupos() {
      this.gruposSeleccionados = [];
    },

    exportExcel() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte,  );
        console.log(data);
        data['A1'].v = 'Unidad';
        data['B1'].v = 'Lectora';
        data['C1'].v = 'Camara';
        data['D1'].v = 'Gps';
        data['E1'].v = 'Observaciones';
        data['F1'].v = 'Operador';
        data['G1'].v = 'Empleado';
        data['H1'].v = 'Sucursal';
        data['I1'].v = 'Bus';
        data['J1'].v = 'Fecha';
        data['K1'].v = 'Email';
        //data['F1'].v = 'Fecha';
        //data['G1'].v = 'Longitud';
        //data['H1'].v = 'Fecha';

        

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
      //  XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },
    exportCSV() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte );
        data['A1'].v = 'Unidad';
        data['B1'].v = 'Lectora';
        data['C1'].v = 'Camara';
        data['D1'].v = 'Gps';
        data['E1'].v = 'Observaciones';
        data['F1'].v = 'Operador';
        data['G1'].v = 'Empleado';
        data['H1'].v = 'Sucursal';
        data['I1'].v = 'Bus';
        data['K1'].v = 'Email';
        //data['F1'].v = 'Fecha';
        //data['G1'].v = 'Longitud';
        //data['H1'].v = 'Fecha';

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
       // XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },

    obtenerDispositivos() {
      this.setearCargando(true);
      axios.get(`${url}devices`, JSON.parse(localStorage.user))
        .then(response => {
          this.dispositivosObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },

    obtenerGrupos() {
      this.setearCargando(true);
      axios.get(`${url}groups`, JSON.parse(localStorage.user))
        .then(response => {
          this.gruposObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
    
     obtenerGeocercas() {
      this.setearCargando(true);
      axios.get(`${url}geofences`, JSON.parse(localStorage.user))
        .then(response => {
          this.geocercasObtenidas = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
  },

  created() {
    this.obtenerDispositivos();
    this.obtenerGrupos();
    this.obtenerGeocercas();
    // this.obtenerUnidades();
    // this.obtenerSesion();
  },

  mounted() {
    // this.obtenerKilometraje();
    if (sessionStorage.aleatorio != 1379248){
    this.$router.push({name: "/" });
  }
  }
}
</script>
<style>
  .telemetria{
    margin: 50px;
    margin-bottom:1%;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-top:15px;
  }
</style>